import axios from "axios";
import { domain } from "../Links/Links";

export async function licensesRequest(setLicenses) {
    const response = await axios.get(domain + '/licenses/')
    console.log(response.data)
    setLicenses(response.data);
}